import { render, staticRenderFns } from "./AddEntityModal.vue?vue&type=template&id=b5521b18&scoped=true"
import script from "./AddEntityModal.vue?vue&type=script&lang=js"
export * from "./AddEntityModal.vue?vue&type=script&lang=js"
import style0 from "./AddEntityModal.vue?vue&type=style&index=0&id=b5521b18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5521b18",
  null
  
)

export default component.exports